import Items, { defaultConfigComponent as ItemConfigComponent } from '@pages/DataBase/Flavors/Items/Items';
import ItemTypes, { defaultConfigComponent as ITConfigComponent } from '@pages/DataBase/Flavors/ItemTypes/ItemTypes';
import Locations, { defaultConfigComponent as LConfigComponent } from '@pages/DataBase/Flavors/Locations/Locations';
import People, { defaultConfigComponent as PConfigComponent } from '@pages/DataBase/Flavors/People/People';
import LocationsType, { defaultConfigComponent as LTConfigComponent } from '@pages/DataBase/Flavors/LocationsType/LocationsType';
import Devices, { defaultConfigComponent as DeviceConfigComponent } from '@pages/DataBase/Flavors/Devices/Devices';
import DeviceType, { defaultConfigComponent as DTConfigComponent } from '@pages/DataBase/DeviceTypes/DeviceTypes';

import EventTypes, { defaultConfigComponent as EvtConfigComponent } from '@pages/DataBase/EventTypes/EventTypes';
import Events, { defaultConfigComponent as EvConfigComponent } from '@pages/DataBase/Events/Events';
import Tasks, { defaultConfigComponent as TConfigComponent } from '@pages/DataBase/Tasks/Tasks';

import Organizations, { defaultConfigComponent as OConfigComponent } from '@pages/DataBase/Organizations/Organizations';
import Labels, { defaultConfigComponent as LaConfigComponent } from '@pages/DataBase/Configuration/Labels/Labels';
import Categories, { defaultConfigComponent as CaConfigComponent } from '@pages/DataBase/Configuration/Categories/Categories';
import Users, { defaultConfigComponent as UConfigComponent } from '@pages/DataBase/Users/Users';
import Roles, { defaultConfigComponent as RConfigComponent } from '@pages/DataBase/Roles/Roles';
import Views, { defaultConfigComponent as VConfigComponent } from '@pages/DataBase/Views/Views';
import Channels, { defaultConfigComponent as ChConfigComponent } from '@pages/DataBase/Channels/Channels';

import KpiOperationType, {
  defaultConfigComponent as KOTConfigComponent,
} from '@pages/DataBase/Configuration/Kpis/KpiOperationType';
import ReadingTypes, { defaultConfigComponent as RTConfigComponent } from '@pages/DataBase/ReadingTypes/ReadingTypes';

import { IConfigComponent } from '@ts/ui-models';
import GlobalDataGrid, { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';
import IndicatorTypes, { defaultConfigComponent as InTyConfigComponent } from '@pages/DataBase/Status/StatusIndicators';
import DevicesPassive, { defaultConfigComponent as DPConfigComponent } from '@pages/DataBase/Flavors/Devices/DevicesPassive';
import DevicesPhysical, { defaultConfigComponent as DPHConfigComponent } from '@pages/DataBase/Flavors/Devices/DevicesPhysical';
import ItemRelations, { defaultConfigComponent as IRConfigComponent } from '@pages/DataBase/Flavors/ItemRelations/ItemRelations';
import Documents, { defaultConfigComponent as DConfigComponent } from '@pages/DataBase/Documents/Documents';
import ItemRelationTypes, {
  defaultConfigComponent as IRTConfigComponent,
} from '@pages/DataBase/Flavors/ItemRelations/ItemRelationTypes';
import HSCode, { defaultConfigComponent as HSConfigComponent } from '@pages/DataBase/HSCode/HSCode';
import DeviceInterfaces, { defaultConfigComponent as DIConfigComponent } from '@pages/DataBase/DeviceInterfaces/DeviceInterfaces';
import { TEntity } from '@ts/ui-models';
import KpiOperations, { defaultConfigComponent as KOConfigComponent } from '@pages/DataBase/Configuration/Kpis/KpiOperations';

export const generateSearchEntitySelector = (
  entityName: TEntity,
  options?: Partial<IConfigComponent>
): { component: React.FC<any>; configComponent: IConfigComponent } => {

  switch (entityName) {
    case 'hscode':
      return {
        component: HSCode,
        configComponent: HSConfigComponent,
      };
    case 'deviceInterface':
      return {
        component: DeviceInterfaces,
        configComponent: DIConfigComponent(),
      };
    case 'document':
      return {
        component: Documents,
        configComponent: DConfigComponent,
      };
    case 'view':
      return {
        component: Views,
        configComponent: VConfigComponent,
      };
    case 'itemRelationType':
      return {
        component: ItemRelationTypes,
        configComponent: IRTConfigComponent,
      };
    case 'itemRelation':
      return {
        component: ItemRelations,
        configComponent: IRConfigComponent,
      };
    case 'statusIndicator':
    case 'indicatorType':
      return {
        component: IndicatorTypes,
        configComponent: InTyConfigComponent,
      };
    case 'readingType':
      return {
        component: ReadingTypes,
        configComponent: RTConfigComponent,
      };
    case 'kpiOperation':
      return {
        component: KpiOperations,
        configComponent: KOConfigComponent,
      };
    case 'kpiOperationType':
      return {
        component: KpiOperationType,
        configComponent: KOTConfigComponent,
      };
    case 'channel':
      return {
        component: Channels,
        configComponent: ChConfigComponent,
      };
    case 'role':
      return {
        component: Roles,
        configComponent: RConfigComponent,
      };
    case 'task':
      return {
        component: Tasks,
        configComponent: TConfigComponent,
      };
    case 'event':
      return {
        component: Events,
        configComponent: EvConfigComponent,
      };
    case 'eventType':
      return {
        component: EventTypes,
        configComponent: EvtConfigComponent,
      };
    case 'assignee':
    case 'user':
      return {
        component: Users,
        configComponent: UConfigComponent,
      };
    case 'category':
      return {
        component: Categories,
        configComponent: CaConfigComponent,
      };
    case 'tag':
    case 'label':
      return {
        component: Labels,
        configComponent: { ...LaConfigComponent, ...options },
      };
    case 'organization':
      return {
        component: Organizations,
        configComponent: OConfigComponent,
      };
    //#region Flavors
    case 'deviceType':
      return {
        component: DeviceType,
        configComponent: DTConfigComponent,
      };
    case 'physicalDevice':
      return {
        component: DevicesPhysical,
        configComponent: DPHConfigComponent(),
      };
    case 'passiveDevice':
      return {
        component: DevicesPassive,
        configComponent: DPConfigComponent(),
      };
    case 'device':
      return {
        component: Devices,
        configComponent: DeviceConfigComponent(),
      };
    case 'people':
    case 'person':
      return {
        component: People,
        configComponent: PConfigComponent(),
      };
    case 'location':
      return {
        component: Locations,
        configComponent: LConfigComponent(),
      };
    case 'geometry':
      return {
        component: Items,
        configComponent: { ...ItemConfigComponent, componentId: 'geometries', fetchURL: '/api/v2/geometries' },
      };
    case 'locationType':
      return {
        component: LocationsType,
        configComponent: LTConfigComponent(),
      };
    case 'elementType':
    case 'itemType':
      return {
        component: ItemTypes,
        configComponent: ITConfigComponent,
      };
    case 'item':
      return {
        component: Items,
        configComponent: ItemConfigComponent,
      };
    //#endregion

    default:
      return {
        component: GlobalDataGrid,
        configComponent: generateConfigComponent(entityName),
      };
  }
};
